import React, { useState } from 'react'
import { TextField, FormGroup } from '@material-ui/core'


const ManuelAddress = ({recipient}) => {
    const [values, setValues ] = useState({name: '', street: '', city: '', contactPerson: '', email: '' })
    const handleSetValue = (value, field) => {
      return setValues({
        ...values,
        [field]: value
      })
    }
      return (
        <FormGroup >
          <TextField
            label='Name'
            name='name'
            value={values.name}
            onChange={e=>handleSetValue(e.target.value, 'name')}
          />
          <TextField
            label='Ansprechparnter'
            name='contactPerson'
            value={values.street}
            onChange={e=>handleSetValue(e.target.value, 'contactPerson')}
          />
          <TextField
            label='Straße'
            name='street'
            value={values.street}
            onChange={e=>handleSetValue(e.target.value, 'street')}
          />
          <TextField
            label='PLZ & Ort'
            name='city'
            value={values.city}
            onChange={e=>handleSetValue(e.target.value, 'city')}
          />
          <TextField
            label='E-Mail'
            name='email'
            type='email'
            value={values.email}
            onChange={e=>handleSetValue(e.target.value, 'email')}
          />
        </FormGroup>
      )
    }

export default ManuelAddress